import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface ICurrentRechner {
  Rechner: string;
}

export interface IProduktseite {
  Produktseite: string;
}

@Injectable()
export class CurrentRechner {

  private rechner$: Subject<ICurrentRechner>;
  private produktseite$: Subject<IProduktseite>;

  constructor() {
    this.rechner$ = new Subject();
    this.produktseite$ = new Subject();
  }

  setRechner(rechner: string) {
    this.rechner$.next({
      Rechner: rechner
    });
  }

  getRechner(): Observable<ICurrentRechner> {
    return this.rechner$.asObservable();
  }

  setProduktseite(produktseite: string) {
    this.produktseite$.next({
      Produktseite: produktseite
    });
  }

  getProduktseite(): Observable<IProduktseite> {
    return this.produktseite$.asObservable();
  }
}
